export default "__VITE_ASSET__DucwIOzO__"